<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="报价单" v-if="findChildren(33)!==-1" name="offer" style="height: 100%;">
				<offer-index />
			</el-tab-pane>
			<el-tab-pane label="销售单" v-if="findChildren(30)!==-1" name="saleorder" style="height: 100%;">
				<saleorder-index />
			</el-tab-pane>
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import offerIndex from './offer/index.vue'
	import saleorderIndex from './saleorder/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				
				activeName: 'offer',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			// if(this.departmentChildren.length!=0){
			// 	this.activeName = this.departmentChildren[0].controller
			// }
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			offerIndex,
			saleorderIndex

		}
	}
</script>
